<template>
  <ion-loading :is-open="showLoading" message="Memproses pesanan..." spinner="circles"></ion-loading>

  <ion-modal :is-open="outletStore.showPaymentOptionDialog" id="payment-option-modal" @willDismiss="onWillDismiss">
    <ion-header class="ion-no-border modern-header">
      <ion-toolbar>
        <ion-title>Metode Pembayaran</ion-title>
      </ion-toolbar>
    </ion-header>

    <div class="payment-container ion-padding">
      <p class="section-label">Pilih cara bayar yang Anda inginkan:</p>

      <ion-list lines="none" class="payment-list">
        <div class="payment-card" @click="goToQrisPayment">
          <div class="payment-icon-box qris-bg">
            <ion-img :src="require('@/assets/qr-code-outline.svg')" class="modern-icon" alt="QRIS" />
          </div>
          <div class="payment-info">
            <h5>Bayar via QRIS</h5>
            <p>Otomatis verifikasi & langsung diproses.</p>
          </div>
          <ion-icon name="chevron-forward-outline" class="arrow-icon"></ion-icon>
        </div>

        <div class="payment-card" @click="processPayment">
          <div class="payment-icon-box cash-bg">
            <ion-img :src="require('@/assets/cash-drawer.svg')" class="modern-icon" alt="Cash" />
          </div>
          <div class="payment-info">
            <h5>Bayar di Kasir</h5>
            <p>Selesaikan pesanan & bayar tunai/kartu.</p>
          </div>
          <ion-icon name="chevron-forward-outline" class="arrow-icon"></ion-icon>
        </div>
      </ion-list>

      <ion-button expand="block" fill="clear" color="medium" @click="onWillDismiss" class="btn-cancel">
        Batal
      </ion-button>
    </div>
  </ion-modal>
  <insufficient-stock-modal
    :is-open="showStockModal"
    :items="outOfStockItems"
    @close="showStockModal = false"
    @edit-order="handleEditOrder"
  />
</template>

<script>
import { useOutletStore } from "@/stores/outlet"
import { IonModal, IonHeader, IonToolbar, IonTitle, IonList, IonLoading, IonImg, IonButton, IonIcon, alertController } from "@ionic/vue";
import { storage } from "../utils/storage";
import InsufficientStockModal from "./insufficientStockModal.vue";

export default {
  name: "paymentOptionDialog",
  props: ["resetOrderList"],
  components: { IonModal, IonHeader, IonToolbar, IonTitle, IonList, IonLoading, IonImg, IonButton, IonIcon, InsufficientStockModal },
  data() {
    return {
      showLoading: false,
      showStockModal: false,
      outOfStockItems: [],
    }
  },
  computed: {
    outletStore() {
      return useOutletStore()
    }
  },
  methods: {
    onWillDismiss() {
      this.outletStore.setshowPaymentOptionDialog(false)
    },
    goToQrisPayment() {
      const outlet = this.outletStore.outlet
      this.$router.push({ name: "orderPaymentQris", id: outlet.outlet_id })
      this.outletStore.setshowPaymentOptionDialog(false)
    },
    getInsufficientStockItems(insufficientStockObj, orderList = []) {
      if (!insufficientStockObj || typeof insufficientStockObj !== "object") {
        return [];
      }

      const ids = Object.keys(insufficientStockObj);
      const items = [];

      ids.forEach(id => {
        let found = null;

        if (Array.isArray(orderList)) {
          for (const item of orderList) {
            if (item.product_detail_id == id || item.product_id == id) {
              found = {
                id,
                name: item.product_name || item.name,
                photo: item.photo || item.image || ""
              };
              break;
            }
            const extraSource = item.link_menu || item.extra;
            if (extraSource && Array.isArray(extraSource)) {
              for (const group of extraSource) {
                const details = group.link_menu_detail || [group];
                if (Array.isArray(details)) {
                  for (const detail of details) {
                    if (detail.product_detail_fkid == id || detail.product_detail_id == id) {
                      found = {
                        id,
                        name: detail.product_name || detail.name,
                        photo: detail.photo || ""
                      };
                      break;
                    }
                  }
                }
                if (found) break;
              }
            }
            if (found) break;
          }
        }

        items.push(found || { id, name: `Produk (ID: ${id})`, photo: "" });
      });

      return items;
    },
    handleEditOrder() {
      this.showStockModal = false;
    },
    async processPayment() {
      this.showLoading = true;
      this.outletStore.setShowCartModal(false)
      this.outletStore.setshowPaymentOptionDialog(false)

      const editId = this.outletStore.editId
      const order = this.outletStore.orderList
      let myHeaders = new Headers();
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}=`);
      let id = parseInt(this.$route.params.id);
      let raw;
      let url = "";
      let method = "";
      if (editId !== "0" && editId !== "") {
        raw = JSON.stringify({ order_list: order });
        url = `v1/transaction/self_order/${editId}`;
        method = "PUT";
      } else {
        raw = JSON.stringify({ outlet_id: id, order_list: order });
        url = "v1/transaction/self_order";
        method = "POST";
      }

      let requestOptions = {
        method: method,
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      try {
        let res = await fetch(
          `${process.env.VUE_APP_BASE_URL}${url}`,
          requestOptions
        );
        let data = await res.json().catch(() => null);

        if (res.status === 200 && data && data.status !== false && data["data"]?.["order_code"]) {
          this.showLoading = false;
          this.resetOrderList();
          let order_code = data["data"]["order_code"],
            qrcode = data["data"]["qrcode"],
            expired = data["data"]["expired"];

          let date = new Date(expired);
          let hours = date.getHours(),
            minutes = date.getMinutes();

          this.$emit("orderData", order_code, qrcode, hours, minutes);
          storage.setHistoryOrder(JSON.stringify({
            outlet_id: id,
            items: order,
            trans: {
              order_code,
              qrcode,
              expired,
            },
          }));
        } else {
          this.showLoading = false;
          const insufficientStockObj = data?.data?.insufficient_stock || data?.insufficient_stock;
          if (insufficientStockObj && Object.keys(insufficientStockObj).length > 0) {
            this.outOfStockItems = this.getInsufficientStockItems(insufficientStockObj, order);
            this.showStockModal = true;
          } else {
            const alert = await alertController.create({
              header: 'Gagal Membuat Pesanan',
              message: data?.message || 'Gagal membuat pesanan. Silakan coba lagi.',
              buttons: ['OK']
            });
            await alert.present();
          }
        }
      } catch (error) {
        this.showLoading = false;
        console.error("Error creating order:", error);
        const alert = await alertController.create({
          header: 'Kesalahan Sistem',
          message: 'Gagal membuat pesanan karena masalah koneksi. Silakan periksa internet Anda.',
          buttons: ['OK']
        });
        await alert.present();
      }
    }
  }
}
</script>

<style scoped>
/* Modal Dialog Styling */
ion-modal#payment-option-modal {
  --width: 90%;
  --max-width: 400px;
  --height: fit-content;
  --border-radius: 24px;
  --box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.modern-header ion-title {
  font-weight: 700;
  font-size: 1.1rem;
  padding-top: 20px;
  text-align: center;
}

.payment-container {
  padding-bottom: 20px;
}

.section-label {
  font-size: 0.85rem;
  color: #666;
  text-align: center;
  margin-bottom: 20px;
}

/* Payment Card Layout */
.payment-list {
  background: transparent;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.payment-card {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 16px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.payment-card:active {
  background: #f9f9f9;
  transform: scale(0.98);
}

/* Icons */
.payment-icon-box {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.qris-bg {
  background: rgba(140, 17, 21, 0.1);
}

.cash-bg {
  background: rgba(56, 128, 255, 0.1);
}

.modern-icon {
  width: 28px;
  height: 28px;
  /* Memberikan warna merah brand ke ikon SVG */
  filter: invert(16%) sepia(89%) saturate(4051%) hue-rotate(349deg) brightness(85%) contrast(97%);
}

/* Typography */
.payment-info {
  flex: 1;
}

.payment-info h5 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: #333;
}

.payment-info p {
  margin: 4px 0 0 0;
  font-size: 0.75rem;
  color: #777;
  line-height: 1.3;
}

.arrow-icon {
  color: #ccc;
  font-size: 1.2rem;
}

.btn-cancel {
  margin-top: 15px;
  font-weight: 600;
  --color: #999;
}
</style>